import { render, staticRenderFns } from "./ClientLayout.vue?vue&type=template&id=1fc8b5ca&scoped=true&"
import script from "./ClientLayout.vue?vue&type=script&lang=js&"
export * from "./ClientLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClientLayout.vue?vue&type=style&index=0&id=1fc8b5ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc8b5ca",
  null
  
)

export default component.exports